import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'


Vue.use(Router)

/**
 * 导航要出现在标签栏，需要配置：
 * 1.路由配置name属性，且对应组件增加name属性，二者必须一致，通常首字母大写
 * 2.路由meta中配置title属性，affix表示是否固定在标签栏
 */

export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: () => import('@/views/redirect/index')
  }]
},
{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true,
  meta: {
    title: '登录'
  }
},
{
  path: '/previewPdf',
  component: () => import('@/components/preview-pdf'),
  hidden: true,
  meta: {
    title: ''
  }
},
{
  path: '/previewDocx',
  component: () => import('@/components/preview-docx'),
  hidden: true,
  meta: {
    title: ''
  }
},

];

// 需要通过权限控制菜单时，过滤asyncRoutes，动态加载，当前未使用权限
export const asyncRoutes = [{
  path: '/',
  component: Layout,
  redirect: '/home',
  name: 'root',
  children: [
    {
      name: 'Home',
      path: 'home',
      component: () => import('@/views/components/eIndex'),
      meta: {
        title: '首页',
        affix: true,
      }
    }
    //首页默认展示产品生命周期管理
    // {
    //   name: 'Administration',
    //   path: '',
    //   component: () => import('@/views/productLifeCycle/administration/administration'),
    //   meta: {
    //     title: '产品生命周期管理',
    //     affix: true,
    //     icon: 'icon-qy-zcflpz'
    //   }
    // }
  ]
},
{
  path: '/system',
  component: Layout,
  redirect: '/system/config',
  // meta: {
  //   title: '系统管理',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'SysConfig',
    path: 'config',
    component: () => import('@/views/config/SysConfig'),
    meta: {
      title: '商品管理基础配置'
    }
  }]
},
//数据看板
{
  path: '/dataBoard',
  component: Layout,
  redirect: '/dataBoard/newProductStatistics',
  children: [
    {
      name: 'newProductStatistics',
      path: 'newProductStatistics',
      component: () => import('@/views/dataBoard/newProductStatistics/newProductStatistics'),
      meta: {
        title: '新品上市/上架统计'
      }
    },
    {
      name: 'salesChangeStatistics',
      path: 'salesChangeStatistics',
      component: () => import('@/views/dataBoard/salesChangeStatistics/salesChangeStatistics'),
      meta: {
        title: '在售品通知统计'
      }
    },
    {
      name: 'agencyWorkbench',
      path: 'agencyWorkbench',
      component: () => import('@/views/dataBoard/agencyWorkbench/agencyWorkbench'),
      meta: {
        title: '代办任务台'
      }
    },

  ]
},
// 新品上架
// {
//   path: '#',
//   meta: {
//     title: '新品上架',
//     icon: 'icon-rizhi'
//   },
//   children: [
//     {
//       name: 'Board',
//       path: 'dash-board',
//       component: () => import('@/views/newProduct/dashBoard'),
//       meta: {
//         title: 'dashBoard'
//       }
//     }
//   ]
// },
{ // 产品管理
  path: '/product',
  component: Layout,
  redirect: '/product/list',
  // meta: {
  //   title: '产品管理',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'productList',
    path: 'list',
    component: () => import('@/views/product/product-list/product-list'),
    meta: {
      title: '产品查询'
    }
  },
  {
    name: 'ProductPrice',
    path: 'productprice',
    component: () => import('@/views/product/productprice/ProductPrice'),
    meta: {
      title: '产品基础价格查询'
    }
  },
  // {
  //   name: 'RetailPriceAudit',
  //   path: 'retailprice/audit',
  //   component: () => import('@/views/product/retailprice/audit'),
  //   meta: {
  //     title: '产品基础零售价审批'
  //   }
  // },
  {
    name: 'RetailPriceIndex',
    path: 'retailprice/index',
    component: () => import('@/views/product/retailprice/index'),
    meta: {
      title: '产品价格维护'
    }
  },
  // {
  //   name: 'ProductClearance',
  //   path: 'clearance',
  //   component: () => import('@/views/product/clearance/ProductClearance'),
  //   meta: {
  //     title: '包件清仓信息维护'
  //   }
  // },
  {
    name: 'baseattr',
    path: 'baseattr',
    component: () => import('@/views/product/ProductBaseAttr/ProductBaseAttr'),
    meta: {
      title: '产品基础属性维护'
    }
  },
  {
    name: 'baseattrImport',
    path: 'baseattrImport',
    component: () => import('@/views/product/ProductBaseAttr/ProductBaseAttrImport'),
    meta: {
      title: '产品基础属性导入'
    }
  },
  {
    name: 'ProductPriceSerach',
    path: 'productPriceSerach',
    component: () => import('@/views/product/productPriceSerach/productPriceSerach'),
    meta: {
      title: '产品完整价格查询'
    }
  },
  {
    name: 'ProductPriceSerachImport',
    path: '/productPriceSerachImport',
    component: () => import('@/views/product/productPriceSerach/productPriceSerach-import'),
    meta: {
      title: '产品完整价格查询导入'
    }
  },
  {
    name: 'KeyProductConfiguration',
    path: '/keyProductConfiguration',
    component: () => import('@/views/product/keyProductConfiguration'),
    meta: {
      title: '重点品型号配置'
    }
  },
  {
    name: 'KeyProductConfigurationImport',
    path: '/keyProductConfigurationImport',
    component: () => import('@/views/product/keyProductConfiguration/import'),
    meta: {
      title: '重点品型号配置导入'
    }
  },
  {
    name: 'KeyProductMonitoring',
    path: '/keyProductMonitoring',
    component: () => import('@/views/productModelDetails/keyProductMonitoring/keyProductMonitoring'),
    meta: {
      title: '重点品监控'
    }
  },
  {
    name: 'videoFullPlatform',
    path: '/videoFullPlatform',
    component: () => import('@/views/shortVideoOverview/videoFullPlatform/videoFullPlatform'),
    meta: {
      title: '电商产品短视频总览'
    }
  },
  {
    name: 'shortVideoFullLog',
    path: '/shortVideoFullLog',
    component: () => import('@/views/shortVideoOverview/shortVideoFullLog/shortVideoFullLog'),
    meta: {
      title: '电商产品短视频完整日志'
    }
  },
  {
    name: 'videoBasicConfiguration',
    path: '/videoBasicConfiguration',
    component: () => import('@/views/shortVideoOverview/videoBasicConfiguration/base-config/base-config'),
    meta: {
      title: '电商产品短视频基础配置'
    }
  },
  {
    name: 'shortVideoManagement',
    path: '/shortVideoManagement',
    component: () => import('@/views/shortVideoOverview/shortVideoManagement/shortVideoManagement'),
    meta: {
      title: '电商产品短视频管理'
    }
  },
  {
    name: 'shortVideoUpload',
    path: '/shortVideoUpload',
    component: () => import('@/views/shortVideoOverview/shortVideoUpload/shortVideoUpload'),
    meta: {
      title: '电商产品短视频上传页面'
    }
  },
  {
    name: 'fileManagement',
    path: '/fileManagement',
    component: () => import('@/views/shortVideoOverview/shortVideoManagement/common/fileManagement'),
    meta: {
      title: '电商产品短视频上传页面'
    }
  },
  // {
  //   name: 'marketdate',
  //   path: 'marketdate',
  //   component: () => import('@/views/product/marketdate/marketdate'),
  //   meta: {
  //     title: '产品上市时间维护'
  //   }
  // },
  // {
  //   name: 'importexcelproduct',
  //   path: 'importexcelproduct',
  //   component: () => import('@/components/importexcel/ImportExcel'),
  //   meta: {
  //     title: '导入'
  //   }
  // },
  {
    name: 'ImportImgProduct',
    path: 'importImgProduct',
    component: () => import('@/components/importImg/ImportImg'),
    meta: {
      title: '图片导入'
    }
  },
  {
    name: 'PriceUphold',
    path: 'price-uphold',
    component: () => import('@/views/product/price-uphold'),
    meta: {
      title: '产品价格系数维护'
    }
  },
  {
    name: 'packageRemovalInformation',
    path: 'packageRemovalInformation',
    component: () => import('@/views/product/packageRemovalInformation'),
    meta: {
      title: '包件下架信息维护'
    }
  },
  {
    name: 'packageRemovalInformationImport',
    path: 'packageRemovalInformationImport',
    component: () => import('@/views/product/packageRemovalInformation/import'),
    meta: {
      title: '包件下架信息维护导入'
    }
  },
  {
    name: 'UpgradeEncoding',
    path: 'upgradeEncoding',
    component: () => import('@/views/product/upgradeEncoding'),
    meta: {
      title: '升级编码'
    }
  },
  {
    name: 'ProductTestingReport',
    path: 'productTestingReport',
    component: () => import('@/views/product/product-testing-report/product-testing-report'),
    meta: {
      title: '产品检测报告'
    }
  },
  {
    name: 'ProductTestingReportImport',
    path: 'productTestingReportImport',
    component: () => import('@/views/product/product-testing-report-import/product-testing-report-import'),
    meta: {
      title: '产品检测报告导入'
    }
  },
  // {
  //   name: 'WanjiaPriceQuery',
  //   path: 'wanjia-price-query',
  //   component: () => import('@/views/wanjia/priceQuery/priceQuery'),
  //   meta: {
  //     title: '万家采购价格查询'
  //   }
  // },
  // {
  //   name: 'WanjiaPriceMaintain',
  //   path: 'wanjia-price-maintain',
  //   component: () => import('@/views/wanjia/priceMaintain/priceMaintain'),
  //   meta: {
  //     title: '万家采购价格维护'
  //   }
  // },
  // {
  //   name: 'WanjiaGoodsPriceQuery',
  //   path: 'wanjia-goods-price-query',
  //   component: () => import('@/views/wanjia/goodsPriceQuery/goodsPriceQuery'),
  //   meta: {
  //     title: '万家商品级采购价格查询'
  //   }
  // },
  ]
},
{
  path: '/pack',
  component: Layout,
  redirect: 'pack/index',
  // meta: {
  //   title: '包件管理',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'pack',
    path: 'index',
    component: () => import('@/views/pack/index'),
    meta: {
      title: '包件查询'
    }
  }

  ]
},
{
  path: '/spu',
  component: Layout,
  redirect: '/newSpu',
  // meta: {
  //   title: 'SPU管理',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'newSpu',
    path: 'newSpu',
    component: () => import('@/views/spu/newSpu'),
    meta: {
      title: 'SPU查询'
    }
  },
  {
    name: 'importexcelbyspu',
    path: 'importexcelbyspu',
    component: () => import('@/components/importexcel/ImportExcel'),
    meta: {
      title: '导入'
    }
  }
  ]
},
{
  path: '/suite',
  component: Layout,
  redirect: '/suite-config',
  // meta: {
  //   title: '系统管理',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'suite-config',
    path: 'suite-config',
    component: () => import('@/views/suite/suiteConfig'),
    meta: {
      title: '套件查询'
    }
  }]
},
{
  path: '/goods',
  component: Layout,
  redirect: '/goods/list',
  // meta: {
  //   title: '商品（SKU）管理',
  //   icon: 'icon-rizhi'
  // },
  children: [
  //   {
  //   name: 'MarketDate',
  //   path: 'marketdate',
  //   component: () => import('@/views/goods/marketdate/MarketDate'),
  //   meta: {
  //     title: '商品上市时间维护'
  //   }
  // },
  // {
  //   name: 'ImportExcel',
  //   path: 'importExcel',
  //   component: () => import('@/components/importexcel/ImportExcel'),
  //   meta: {
  //     title: '导入'
  //   }
  // },
  // {
  //   name: 'ImportImg',
  //   path: 'importImg',
  //   component: () => import('@/components/importImg/ImportImg'),
  //   meta: {
  //     title: '图片导入'
  //   }
  // },
  // {
  //   name: 'Clearance',
  //   path: 'clearance',
  //   component: () => import('@/views/goods/clearance/Clearance'),
  //   meta: {
  //     title: '清仓销售状态维护'
  //   }
  // },
  // {
  //   name: 'StoreLocation',
  //   path: 'storelocation',
  //   component: () => import('@/views/goods/storelocation/StoreLocation'),
  //   meta: {
  //     title: '店铺商品定位维护'
  //   }
  // },
  // {
  //   name: 'SalesPriceAudit',
  //   path: 'salesprice/audit',
  //   component: () => import('@/views/goods/salesprice/audit'),
  //   meta: {
  //     title: '商品销售价审批'
  //   }
  // },
  {
    name: 'SalesPriceIndex',
    path: 'salesprice/index',
    component: () => import('@/views/goods/salesprice/index'),
    meta: {
      title: '商品销售价维护'
    }
  },
  {
    name: 'SettlementPriceMain',
    path: 'settlementPriceMain',
    component: () => import('@/views/goods/settlementPriceMain/settlementPriceMain'),
    meta: {
      title: '商品结算价维护'
    }
  },
  {
    name: 'SettlementPriceMainImport',
    path: 'settlementPriceMainImport',
    component: () => import('@/views/goods/settlementPriceMain/settlementPriceMain-import'),
    meta: {
      title: '包件结算价格维护导入'
    }
  },
  {
    name: 'SpecialLiveManage',
    path: 'specialLiveManage',
    component: () => import('@/views/goods/specialLiveManage/specialLiveManage'),
    meta: {
      title: '商品特殊直播价管理'
    }
  },
  {
    name: 'SpecialLiveManageImport',
    path: 'specialLiveManageImport',
    component: () => import('@/views/goods/specialLiveManage/specialLiveManage-import'),
    meta: {
      title: '商品特殊直播价导入'
    }
  },
  {
    name: 'LivePriceUphold',
    path: 'livePriceUphold',
    component: () => import('@/views/goods/livePriceUphold/livePriceUphold'),
    meta: {
      title: '商品直播价维护'
    }
  },
  {
    name: 'LivePriceUpholdImport',
    path: 'livePriceUpholdImport',
    component: () => import('@/views/goods/livePriceUphold/livePriceUphold-import'),
    meta: {
      title: '商品直播价导入'
    }
  },
  {
    name: 'SalesPriceImport',
    path: 'salesprice/import',
    component: () => import('@/views/goods/salesprice/import'),
    meta: {
      title: '商品实际执行价格导入'
    }
  },
  {
    name: 'CommodityPriceChange',
    path: 'commodityPriceChange',
    component: () => import('@/views/goods/commodityPriceChange/commodityPriceChange'),
    meta: {
      title: '商品价格变更清单'
    }
  },
  {
    name: 'SalesPriceUphold',
    path: 'salesprice/price-uphold',
    component: () => import('@/views/goods/salesprice/price-uphold'),
    meta: {
      title: '商品清仓系数维护'
    }
  },
  {
    name: 'SalesPriceQuery',
    path: 'salesprice/query',
    component: () => import('@/views/goods/salesprice/query'),
    meta: {
      title: '商品价格查询'
    }
  },
  // {
  //   name: 'SalespriceLog',
  //   path: '/salespriceLog',
  //   component: () => import('@/views/goods/salespriceLog/salespriceLog'),
  //   meta: {
  //     title: '商品销售价查询完整日志'
  //   }
  // },
  // {
  //   name: 'CategoryStyle',
  //   path: 'categorystyle',
  //   component: () => import('@/views/goods/categorystyle/CategoryStyle'),
  //   meta: {
  //     title: '风格、品类维护'
  //   }
  // },
  // SKU
  {
    name: 'goodsList',
    path: 'list',
    component: () => import('@/views/goods/goods-list/goods-list'),
    meta: {
      title: 'SKU查询'
    }
  },
  // 商品发货周期维护
  // {
  //   name: 'deliveryCycle',
  //   path: 'delivery',
  //   component: () => import('@/views/goods/deliverycycle'),
  //   meta: {
  //     title: '商品后端发货周期维护'
  //   }
  // },
  {
    name: 'DeliverycycleSalesEnd',
    path: 'deliverycycleSalesEnd',
    component: () => import('@/views/goods/deliverycycleSalesEnd'),
    meta: {
      title: '商品销售端发货周期维护'
    }
  },
  {
    name: 'DeliverycycleSalesEndImport',
    path: 'deliverycycleSalesEndImport',
    component: () => import('@/views/goods/deliverycycleSalesEnd/import'),
    meta: {
      title: '商品销售端发货周期维护导入'
    }
  },
  {
    name: 'Hierarchy',
    path: 'hierarchy',
    component: () => import('@/views/goods/hierarchy/Hierarchy'),
    meta: {
      title: '多层级查询'
    }
  },
  {
    name: 'PriceQuery',
    path: 'price/index',
    component: () => import('@/views/goods/price/index'),
    meta: {
      title: '商品完整价格查询'
    }
  },
  {
    name: 'baseattr',
    path: 'baseattr',
    component: () => import('@/views/goods/goodsBaseattr/index'),
    meta: {
      title: '商品信息管理'
    }
  },
  {
    name: 'GoodsBaseattrImport',
    path: 'goodsBaseattrImport',
    component: () => import('@/views/goods/goodsBaseattr/import'),
    meta: {
      title: '商品基础属性导入'
    }
  },
  // {
  //   name: 'DaboPriceMaintenance',
  //   path: 'daboPriceMaintenance',
  //   component: () => import('@/views/goods/daboPriceMaintenance/daboPriceMaintenance'),
  //   meta: {
  //     title: '商品达播价格维护'
  //   }
  // },
  // {
  //   name: 'DaboPriceMaintenanceImport',
  //   path: 'daboPriceMaintenanceImport',
  //   component: () => import('@/views/goods/daboPriceMaintenance/daboPriceMaintenance-import'),
  //   meta: {
  //     title: '商品达播价格导入'
  //   }
  // },
  {
    name: 'GoodsInfoNotice',
    path: 'goodsInfoNotice',
    component: () => import('@/views/goods/goodsInfoNotice/goodsInfoNotice'),
    meta: {
      title: '在售商品消息通知'
    }
  },
  ]
},
{
  path: '/',
  component: Layout,
  // meta: {
  //   title: '新品上架',
  //   icon: 'icon-rizhi'
  // },
  children: [
    // {
    //   name: 'dash-board',
    //   path: '/newProduct/dashBoard',
    //   component: () => import('@/views/newProduct/dashBoard'),
    //   meta: {
    //     title: '新品制作情况总览'
    //   }
    // },
    // {
    //   path: '/newProduct/allocateNode',
    //   name: 'AllocateNode',
    //   component: () => import('@/views/newProduct/allocateNode'),
    //   meta: {
    //     title: '基础数据配置'
    //   }
    // },
    // {
    //   path: '/newProduct/productList',
    //   name: 'ProductList',
    //   component: () => import('@/views/newProduct/productList'),
    //   meta: {
    //     title: '新品进度更新'
    //   }
    // },
    {
      path: '/newProduct/theReport',
      name: 'TheReport',
      component: () => import('@/views/newProduct/theReport'),
      meta: {
        title: '新品进度报表'
      }
    },
    {
      path: '/newProduct/listingList',
      name: 'ListingList',
      component: () => import('@/views/newProduct/newproduct-listManage/listing-list/ListingList'),
      meta: {
        title: '新品上市清单'
      }
    },
    {
      path: '/newProduct/createList',
      name: 'CreateList',
      component: () => import('@/views/newProduct/newproduct-listManage/create-list/CreateList'),
      meta: {
        title: '新增编辑上市清单'
      }
    },
    {
      path: '/newProduct/listing-list-details',
      name: 'ListingListDetails',
      component: () => import('@/views/newProduct/newproduct-listManage/listing-list-details/ListingListDetails'),
      meta: {
        title: '上市清单详情'
      }
    },
    {
      path: '/newProduct/product-price-list',
      name: 'ProductPriceList',
      component: () => import('@/views/newProduct/newproduct-listManage/product-price-list/ProductPriceList'),
      meta: {
        title: '产品价格清单'
      }
    },
    {
      path: '/newProduct/newProduct-arrival',
      name: 'NewProductArrival',
      component: () => import('@/views/newProduct/newProduct-arrival/NewProductArrival'),
      meta: {
        title: '新品上架'
      }
    },
    {
      path: '/newProduct/fast-product-arrival',
      name: 'FastProductArrival',
      component: () => import('@/views/newProduct/fast-product-arrival/FastProductArrival'),
      meta: {
        title: '在售品信息处理'
      }
    },
    {
      path: '/newProduct/fast-product-arrival-data',
      name: 'FastProductArrivalData',
      component: () => import('@/views/newProduct/fast-product-arrival-data/FastProductArrivalData'),
      meta: {
        title: '在售品通知数据'
      }
    },
    {
      path: '/newProduct/newproduct-launch-count',
      name: 'NewproductProcessData',
      component: () => import('@/views/newProduct/newproduct-launch-count/NewproductLaunchCount'),
      meta: {
        title: '新品上架统计'
      }
    },
    {
      path: '/newProduct/samplePicturesImport',
      name: 'SamplePicturesImport',
      component: () => import('@/views/newProduct/sample-pictures-import/sample-pictures-import'),
      meta: {
        title: '样品首套图上传'
      }
    },
    {
      path: '/newProduct/imgImport',
      name: 'ImgImport',
      component: () => import('@/views/newProduct/sample-pictures-import/img-import'),
      meta: {
        title: '上传图片'
      }
    },

    {
      name: 'NewProductAdd',
      path: '/newProduct/newProductAdd',
      component: () => import('@/views/newProduct/data/newProductAdd'),
      meta: {
        title: '产品基础信息导入'
      }
    },
    {
      name: 'NewProductShootBatch',
      path: '/newProduct/newProductShootBatch',
      component: () => import('@/views/newProduct/data/newProductShootBatch'),
      meta: {
        title: '拍摄批次导入'
      }
    },
    // {
    //   name: 'NewProductModifyStatus',
    //   path: '/newProduct/newProductModifyStatus',
    //   component: () => import('@/views/newProduct/data/newProductModifyStatus'),
    //   meta: {
    //     title: '流程节点批量导入'
    //   }
    // },
    {
      name: 'NewProductAddTime2Remark',
      path: '/newProduct/newProductAddTime2Remark',
      component: () => import('@/views/newProduct/data/newProductAddTime2Remark'),
      meta: {
        title: '上新时间和备注导入'
      }
    },
    {
      name: 'ReviewedSkuImport',
      path: '/newProduct/reviewedSkuImport',
      component: () => import('@/views/newProduct/data/reviewedSkuImport'),
      meta: {
        title: '已评审产品导入'
      }
    },
    {
      name: 'newproductProcess',
      path: '/newProduct/newproduct-process',
      component: () => import('@/views/newProduct/newproduct-process/newproduct-process'),
      meta: {
        title: '新品进度更新'
      }
    },
    {
      name: 'PhotographerFilmRepairSummary',
      path: '/newProduct/photographerFilmRepairSummary',
      component: () => import('@/views/newProduct/photographerFilmRepairSummary/photographerFilmRepairSummary'),
      meta: {
        title: '修片汇总'
      }
    },
    {
      name: 'PhotographerFilmRepairDetails',
      path: '/newProduct/photographerFilmRepairDetails',
      component: () => import('@/views/newProduct/photographerFilmRepairDetails/photographerFilmRepairDetails'),
      meta: {
        title: '修片明细'
      }
    },
    {
      name: 'ProductShootingImageManagement',
      path: '/newProduct/productShootingImageManagement',
      component: () => import('@/views/newProduct/productShootingImageManagement/productShootingImageManagement'),
      meta: {
        title: '修片/切片图片管理'
      }
    },
    {
      name: 'StoreDecorationImageManagement',
      path: '/newProduct/storeDecorationImageManagement',
      component: () => import('@/views/newProduct/storeDecorationImageManagement/storeDecorationImageManagement'),
      meta: {
        title: '店铺装修图管理'
      }
    },
    {
      name: 'StoreDecorationTemplateConfig',
      path: '/newProduct/storeDecorationTemplateConfig',
      component: () => import('@/views/newProduct/storeDecorationImageManagement/storeDecorationTemplateConfig'),
      meta: {
        title: '店铺装修模板配置'
      }
    },
    {
      name: 'PlatformImageRuleConfig',
      path: '/newProduct/platformImageRuleConfig',
      component: () => import('@/views/newProduct/platformImageRuleConfig/platformImageRuleConfig'),
      meta: {
        title: '平台图片规则配置'
      }
    },
    {
      name: 'ImageUploadTask',
      path: '/newProduct/imageUploadTask',
      component: () => import('@/views/newProduct/imageUploadTask/imageUploadTask'),
      meta: {
        title: '上传任务'
      }
    },
    {
      name: 'ProductModelManagement',
      path: '/newProduct/productModelManagement',
      component: () => import('@/views/newProduct/productModelManagement/productModelManagement'),
      meta: {
        title: '产品模型文件管理'
      }
    },
    {
      name: 'SliceAddressManagement',
      path: '/newProduct/sliceAddressManagement',
      component: () => import('@/views/newProduct/sliceAddressManagement/sliceAddressManagement'),
      meta: {
        title: '切片地址管理'
      }
    },
    {
      name: 'ProductImageSummary',
      path: '/newProduct/productImageSummary',
      component: () => import('@/views/newProduct/productImageSummary/productImageSummary'),
      meta: {
        title: '修片图片汇总'
      }
    },
    {
      name: 'SectionNumberSummary',
      path: '/newProduct/sectionNumberSummary',
      component: () => import('@/views/newProduct/sectionNumberSummary/sectionNumberSummary'),
      meta: {
        title: '切片数量汇总'
      }
    },
    {
      name: 'ProductModelSummary',
      path: '/newProduct/productModelSummary',
      component: () => import('@/views/newProduct/productModelSummary/productModelSummary'),
      meta: {
        title: '产品模型汇总数据'
      }
    },
    {
      name: 'ReturnReasonStatistics',
      path: '/newProduct/returnReasonStatistics',
      component: () => import('@/views/newProduct/returnReasonStatistics/returnReasonStatistics'),
      meta: {
        title: '退回原因统计'
      }
    },
    {
      name: 'SectionNoticeStatistics',
      path: '/newProduct/sectionNoticeStatistics',
      component: () => import('@/views/newProduct/sectionNoticeStatistics/sectionNoticeStatistics'),
      meta: {
        title: '切片通知统计'
      }
    },
    {
      name: 'TemporaryProductDataSheet',
      path: '/newProduct/temporaryProductDataSheet',
      component: () => import('@/views/newProduct/temporaryProductDataSheet/temporaryProductDataSheet'),
      meta: {
        title: '临时产品数据'
      }
    },
    {
      name: 'NewProductFirstBatchLibrary',
      path: '/newProduct/newProductFirstBatchLibrary',
      component: () => import('@/views/newProduct/newProductFirstBatchLibrary/newProductFirstBatchLibrary'),
      meta: {
        title: '新品首批库'
      }
    },
    {
      name: 'photographySalaryAccounting',
      path: '/newProduct/photographySalaryAccounting',
      component: () => import('@/views/newProduct/photographySalaryAccounting/photographySalaryAccounting'),
      meta: {
        title: '摄影师工资核算'
      }
    },
    {
      name: 'photographySalaryAccountingSummary',
      path: '/newProduct/photographySalaryAccountingSummary',
      component: () => import('@/views/newProduct/photographySalaryAccountingSummary/photographySalaryAccountingSummary'),
      meta: {
        title: '摄影师工资核算汇总'
      }
    },
    {
      name: 'FilmRepairmanSalarySummary',
      path: '/newProduct/filmRepairmanSalarySummary',
      component: () => import('@/views/newProduct/filmRepairmanSalarySummary/filmRepairmanSalarySummary'),
      meta: {
        title: '修片师工资核算汇总'
      }
    },
    {
      name: 'FilmRepairmanSalaryAllocation',
      path: '/newProduct/filmRepairmanSalaryAllocation',
      component: () => import('@/views/newProduct/filmRepairmanSalaryAllocation'),
      meta: {
        title: '修片师提成配置'
      }
    },
    {
      name: 'ShootingNodesConfiguration',
      path: '/newProduct/shootingNodesConfiguration',
      component: () => import('@/views/newProduct/shootingNodesConfiguration'),
      meta: {
        title: '摄影师及提成配置'
      }
    },
    {
      name: 'photographerConfigurationImport',
      path: '/photographerConfigurationImport',
      component: () => import('@/views/newProduct/shootingNodesConfiguration/photographerConfiguration/import'),
      meta: {
        title: '摄影师配置导入'
      }
    },
    {
      name: 'newproductOverview',
      path: '/newProduct/newproduct-overview',
      component: () => import('@/views/newProduct/newproduct-overview/newproduct-overview'),
      meta: {
        title: '新品流程总览'
      }
    },
    // {
    //   name: 'newproductBaseConfig',
    //   path: '/newProduct/newproduct-baseConfig',
    //   component: () => import('@/views/newProduct/basicConfiguration/base-config/base-config'),
    //   meta: {
    //     title: '预退基础配置'
    //   }
    // },
    {
      name: 'lifecycleConfiguration',
      path: '/newProduct/lifecycleConfiguration',
      component: () => import('@/views/newProduct/newproduct-overview/lifecycleConfiguration/lifecycleConfiguration'),
      meta: {
        title: '产品生命周期基础配置'
      }
    },
    {
      name: 'lifeCycleManagement',
      path: '/newProduct/lifeCycleManagement',
      component: () => import('@/views/newProduct/newproduct-overview/lifeCycleManagement/lifeCycleManagement'),
      meta: {
        title: '大型号品类分布'
      }
    },
    {
      name: 'productUnsalable',
      path: '/newProduct/productUnsalable',
      component: () => import('@/views/newProduct/newproduct-overview/lifeCycleManagement/productUnsalable'),
      meta: {
        title: '产品滞销'
      }
    },
    {
      name: 'newproductDetail',
      path: '/newProduct/newproduct-detail',
      component: () => import('@/views/newProduct/newproduct-detail/newproduct-detail'),
      meta: {
        title: '新品详情'
      }
    },
    {
      name: 'newproductAdd',
      path: '/newProduct/newproduct-add',
      component: () => import('@/views/newProduct/newproduct-add/newproduct-add'),
      meta: {
        title: '新增SPU'
      }
    },
    {
      name: 'skuList',
      path: '/newProduct/sku-list/:type',
      component: () => import('@/views/newProduct/sku-list/sku-list'),
      meta: {
        title: '已评审产品汇总表'
      }
    },
    {
      name: 'skuList',
      path: '/newProduct/productInfomationUpload',
      component: () => import('@/views/newProduct/newproduct-detail/productInfomationUpload/productInfomationUpload'),
      meta: {
        title: '产品资料上传'
      }
    },
    {
      name: 'LiveOrderDetails',
      path: '/newProduct/liveOrderDetails',
      component: () => import('@/views/newProduct/liveOrderDetails/liveOrderDetails'),
      meta: {
        title: '直播订单明细'
      }
    },
  ]
},
{
  path: '/order/orderDistribution',
  component: Layout,
  // meta: {
  //   title: '运营分析',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'OrderDistribution',
    path: '/analysis/order',
    component: () => import('@/views/operationAnalysis/operationAnalysis'),
    meta: {
      title: '订单交期'
    }
  },
  {
    name: 'LackPackagesSummaryRoute',
    path: '/lackPackagesSummary',
    component: () => import('@/views/operationAnalysis/lackPackagesSummary/lackPackagesSummary'),
    meta: {
      title: '缺货回复完成进度表'
    }
  },
  {
    name: 'LackPackagesDetailsRoute',
    path: '/lackPackagesDetails',
    component: () => import('@/views/operationAnalysis/lackPackagesDetails/lackPackagesDetails'),
    meta: {
      title: '缺货回复完成进度详情'
    }
  },
  {
    name: 'PrePlanClassify',
    path: '/order/orderDistribution/prePlanClassify',
    component: () => import('@/views/preSalePlanNew/child/configuration/prePlanClassify/prePlanClassify'),
    meta: {
      title: '预销产品分类配置'
    }
  },
  {
    name: 'PrePlanClassifyImport',
    path: '/order/orderDistribution/prePlanClassifyImport',
    component: () => import('@/views/preSalePlanNew/child/configuration/prePlanClassify/prePlanClassifyImport'),
    meta: {
      title: '预销产品分类批量导入'
    }
  },
  // {
  //   name: 'LackPackagesSummary',
  //   path: '/lackPackagesSummary',
  //   component: () => import('@/views/operationAnalysis/lackPackagesSummary/lackPackagesSummary'),
  //   meta: {
  //     title: '缺货包件汇总表'
  //   }
  // },
  // {
  //   name: 'LackPackagesDetails',
  //   path: '/lackPackagesDetails',
  //   component: () => import('@/views/operationAnalysis/lackPackagesDetails/lackPackagesDetails'),
  //   meta: {
  //     title: '缺货包件详情'
  //   }
  // },
  // {
  //   name: 'FifteenActualOffline',
  //   path: '/fifteenActualOffline',
  //   component: () => import('@/views/operationAnalysis/fifteenActualOffline/fifteenActualOffline'),
  //   meta: {
  //     title: '入库信息'
  //   }
  // },
  // {
  //   name: 'PreSalePlan',
  //   path: '/preSalePlan',
  //   component: () => import('@/views/preSalePlan/preSalePlan'),
  //   meta: {
  //     title: '预销计划'
  //   }
  // },
  // 预销计划-旧
  {
    name: 'PreSalePlanNew',
    path: '/preSalePlanNew',
    component: () => import('@/views/preSalePlanNew/preSalePlanNew'),
    meta: {
      title: '预销计划'
    }
  },
  {
    name: 'CommodityImport',
    path: '/commodityImport',
    component: () => import('@/views/preSalePlanNew/components/mainContent/commodity/import.vue'),
    meta: {
      title: '预销计划商品信息导入'
    }
  },
  // 新品预销-动销监控
  {
    name: 'NewProductPreSale',
    path: '/newProductPreSale',
    component: () => import('@/views/newProductPreSale/newProductPreSale'),
    meta: {
      title: '新品预销-动销监控'
    }
  },
  // {
  //   name: 'BeforeSubmissionFullPlatform',
  //   path: '/beforeSubmissionFullPlatform',
  //   component: () => import('@/views/smallPieceManagement/beforeSubmissionFullPlatform/beforeSubmissionFullPlatform'),
  //   meta: {
  //     title: '小件预销管理'
  //   }
  // },
  // {
  //   name: 'BeforeSubmissionFullPlatformImport',
  //   path: '/beforeSubmissionFullPlatformImport',
  //   component: () => import('@/views/smallPieceManagement/beforeSubmissionFullPlatform/components/beforeSubmissionFullPlatformImport'),
  //   meta: {
  //     title: '小件预销管理全平台提报前导入'
  //   }
  // },
  // {
  //   name: 'BeforeSubmissionStroeImport',
  //   path: '/beforeSubmissionStroeImport',
  //   component: () => import('@/views/smallPieceManagement/beforeSubmissionFullPlatform/components/beforeSubmissionStroeImport'),
  //   meta: {
  //     title: '小件预销管理店铺提报前导入'
  //   }
  // },
  // {
  //   name: 'BasicConfiguration',
  //   path: '/basicConfiguration',
  //   component: () => import('@/views/smallPieceManagement/basicConfiguration/base-config/base-config'),
  //   meta: {
  //     title: '小件预销基础配置'
  //   }
  // },
  // {
  //   name: 'SmallPieceFollowUpForm',
  //   path: '/smallPieceFollowUpForm',
  //   component: () => import('@/views/smallPieceManagement/smallPieceFollowUpForm/smallPieceFollowUpForm'),
  //   meta: {
  //     title: '小件预销跟进表'
  //   }
  // },
  // {
  //   name: 'SmallHomeAppliances',
  //   path: '/smallHomeAppliances',
  //   component: () => import('@/views/smallHomeAppliances/smallHomeAppliances/smallHomeAppliances'),
  //   meta: {
  //     title: '小家电预销管理'
  //   }
  // },
  // {
  //   name: 'SmallHomeBeforeSubmissionFullPlatformImport',
  //   path: '/smallHomeBeforeSubmissionFullPlatformImport',
  //   component: () => import('@/views/smallHomeAppliances/smallHomeAppliances/components/beforeSubmissionFullPlatformImport'),
  //   meta: {
  //     title: '小家电预销管理全平台提报前导入'
  //   }
  // },
  // {
  //   name: 'SmallHomeBeforeSubmissionStroeImport',
  //   path: '/smallHomeBeforeSubmissionStroeImport',
  //   component: () => import('@/views/smallHomeAppliances/smallHomeAppliances/components/beforeSubmissionStroeImport'),
  //   meta: {
  //     title: '小家电预销管理店铺提报前导入'
  //   }
  // },
  // {
  //   name: 'SmallHomeAppliancesBaseConfig',
  //   path: '/smallHomeAppliancesBaseConfig',
  //   component: () => import('@/views/smallHomeAppliances/basicConfiguration/base-config/base-config'),
  //   meta: {
  //     title: '小家电预销基础配置'
  //   }
  // },
  // {
  //   name: 'SmallHomeAppliancesFollowUpForm',
  //   path: '/smallHomeAppliancesFollowUpForm',
  //   component: () => import('@/views/smallHomeAppliances/smallHomeAppliancesFollowUpForm/smallHomeAppliancesFollowUpForm'),
  //   meta: {
  //     title: '小家电预销跟进表'
  //   }
  // },
  {
    name: 'OrderVerification',
    path: '/orderVerification',
    component: () => import('@/views/smallHomeAppliances/orderVerification'),
    meta: {
      title: '订单校验'
    }
  },
  // {
  //   name: 'JDProductSalesTable',
  //   path: '/JDProductSalesTable',
  //   component: () => import('@/views/productModelDetails/JDProductSalesTable/JDProductSalesTable'),
  //   meta: {
  //     title: '京东自营入仓产品销量表'
  //   }
  // },
  {
    name: 'productSalesData',
    path: '/productSalesData',
    component: () => import('@/views/productSalesData/productSalesData'),
    meta: {
      title: '商品销量数据'
    }
  },
  // {
  //   name: 'BoomSheet',
  //   path: '/boomSheet',
  //   component: () => import('@/views/boomSheet/boomSheet'),
  //   meta: {
  //     title: '基础信息表'
  //   }
  // },
  {
    name: 'ClearanceBasicConfig',
    path: '/clearanceBasicConfig',
    component: () => import('@/views/clearanceManagement/basicConfiguration/base-config/base-config'),
    meta: {
      title: '清仓基础配置'
    }
  },
  {
    name: 'WarehouseCearanceManagement',
    path: '/warehouseCearanceManagement',
    component: () => import('@/views/clearanceManagement/warehouseCearanceManagement'),
    meta: {
      title: '清仓管理'
    }
  },
  {
    name: 'ClearanceManagementStoreImport',
    path: '/clearanceManagementStoreImport',
    component: () => import('@/views/clearanceManagement/warehouseCearanceManagement/store/storeImport'),
    meta: {
      title: '清仓管理店铺导入'
    }
  },
  // {
  //   name: 'delistingFollowUpForm',
  //   path: '/delistingFollowUpForm',
  //   component: () => import('@/views/clearanceManagement/delistingFollowUpForm'),
  //   meta: {
  //     title: '退市/预退市跟进表'
  //   }
  // },
  // {
  //   name: 'delistingFollowUpFormImport',
  //   path: '/delistingFollowUpFormImport',
  //   component: () => import('@/views/clearanceManagement/delistingFollowUpForm/delistingFollowUpFormImport'),
  //   meta: {
  //     title: '退市/预退市跟进表导入'
  //   }
  // },
  {
    name: 'Administration',
    path: '/productLifeCycle/administration',
    component: () => import('@/views/productLifeCycle/administration/administration'),
    meta: {
      title: '产品生命周期'
    }
  },
  // {
  //   name: 'ProductPreReturn',
  //   path: '/productPreReturn',
  //   component: () => import('@/views/productLifeCycle/productPreReturn/productPreReturn'),
  //   meta: {
  //     title: '电商预退批次'
  //   }
  // },
  {
    name: 'retirementAnalysis',
    path: '/retirementAnalysis',
    component: () => import('@/views/productLifeCycle/retirementAnalysis/retirementAnalysis'),
    meta: {
      title: '电商预退产品分析表'
    }
  },
  {
    name: 'PreReturnedProducts',
    path: '/preReturnedProducts',
    component: () => import('@/views/productLifeCycle/preReturnedProducts/preReturnedProducts'),
    meta: {
      title: '电商预退产品清单'
    }
  },
  {
    name: 'PreReturnedProductsImport',
    path: '/preReturnedProductsImport',
    component: () => import('@/views/productLifeCycle/preReturnedProducts/preReturnedProductsImport'),
    meta: {
      title: '电商预退产品清单导入'
    }
  },
  {
    name: 'Baseconfig',
    path: 'baseconfig',
    component: () => import('@/views/preSalePlanNew/child/configuration/base-config/base-config'),
    meta: {
      title: '预销计划基础配置'
    }
  },
  {
    name: 'LiveBroadcast',
    path: 'liveBroadcast',
    component: () => import('@/views/preSalePlanNew/child/liveBroadcast'),
    meta: {
      title: '直播预销管理'
    }
  },
  {
    name: 'LiveBroadcastSkuImport',
    path: 'liveBroadcastSkuImport',
    component: () => import('@/views/preSalePlanNew/child/liveBroadcast/sku/import'),
    meta: {
      title: '直播预销管理-商品导入'
    }
  },
  // {
  //   name: 'RefundManagementBaseConfig',
  //   path: '/refundManagementBaseConfig',
  //   component: () => import('@/views/refundManagement/basicConfiguration/base-config/base-config'),
  //   meta: {
  //     title: '退款管理基础配置'
  //   }
  // },
  // {
  //   name: 'OfflineRegistration',
  //   path: '/offlineRegistration',
  //   component: () => import('@/views/refundManagement/offlineRegistration'),
  //   meta: {
  //     title: '退款登记'
  //   }
  // },
  // {
  //   name: 'OfflineRegistrationECOImport',
  //   path: '/offlineRegistrationECOImport',
  //   component: () => import('@/views/refundManagement/offlineRegistration/ECO/import'),
  //   meta: {
  //     title: 'ECO退款登记导入'
  //   }
  // },
  // {
  //   name: 'OfflineRegistrationB2Cmport',
  //   path: '/offlineRegistrationB2CImport',
  //   component: () => import('@/views/refundManagement/offlineRegistration/B2C/import'),
  //   meta: {
  //     title: 'B2C退款登记导入'
  //   }
  // },
  // {
  //   name: 'OfflineReview',
  //   path: '/offlineReview',
  //   component: () => import('@/views/refundManagement/offlineReview'),
  //   meta: {
  //     title: '线下审核'
  //   }
  // },
  // {
  //   name: 'OfflineReviewECOImport',
  //   path: '/offlineReviewECOImport',
  //   component: () => import('@/views/refundManagement/offlineReview/ECO/import'),
  //   meta: {
  //     title: 'ECO线下审核导入'
  //   }
  // },
  // {
  //   name: 'OfflineReviewECOExoportRecord',
  //   path: '/offlineReviewECOExoportRecord',
  //   component: () => import('@/views/refundManagement/offlineReview/ECO/exoportRecord'),
  //   meta: {
  //     title: '线下审核ECO导出明细'
  //   }
  // },
  // {
  //   name: 'OfflineReviewB2CExoportRecord',
  //   path: '/offlineReviewB2CExoportRecord',
  //   component: () => import('@/views/refundManagement/offlineReview/B2C/exoportRecord'),
  //   meta: {
  //     title: '线下审核B2C导出明细'
  //   }
  // },
  // {
  //   name: 'OfflineReviewB2CImport',
  //   path: '/offlineReviewB2CImport',
  //   component: () => import('@/views/refundManagement/offlineReview/B2C/import'),
  //   meta: {
  //     title: 'B2C线下审核导入'
  //   }
  // },
  // {
  //   name: 'RefundSummary',
  //   path: '/refundSummary',
  //   component: () => import('@/views/refundManagement/refundSummary'),
  //   meta: {
  //     title: '退款汇总'
  //   }
  // },
  {
    name: 'QualityTestingManageBaseConfig',
    path: '/qualityTestingManageBaseConfig',
    component: () => import('@/views/qualityTestingManage/basicConfiguration'),
    meta: {
      title: '质检基础配置'
    }
  },
  {
    name: 'CustomerServicePersonnelImport',
    path: '/customerServicePersonnelImport',
    component: () => import('@/views/qualityTestingManage/basicConfiguration/customerServicePersonnel/import'),
    meta: {
      title: '客服人员配置导入'
    }
  },
  {
    name: 'QualityTestingRegister',
    path: '/qualityTestingRegister',
    component: () => import('@/views/qualityTestingManage/qualityTestingRegister/qualityTestingRegister'),
    meta: {
      title: '质检登记'
    }
  },
  {
    name: 'QualityTestingRegisterImport',
    path: '/qualityTestingRegisterImport',
    component: () => import('@/views/qualityTestingManage/qualityTestingRegister/import'),
    meta: {
      title: '质检登记导入'
    }
  },
  {
    name: 'QualityTestingAppealReview',
    path: '/qualityTestingAppealReview',
    component: () => import('@/views/qualityTestingManage/qualityTestingAppealReview/qualityTestingAppealReview'),
    meta: {
      title: '质检申诉审核'
    }
  },
  // {
  //   name: 'PreliminaryReview',
  //   path: '/preliminaryReview',
  //   component: () => import('@/views/qualityTestingManage/preliminaryReview'),
  //   meta: {
  //     title: '质检登记'
  //   }
  // },
  // {
  //   name: 'PreliminaryReviewImport',
  //   path: '/preliminaryReviewImport',
  //   component: () => import('@/views/qualityTestingManage/preliminaryReview/import'),
  //   meta: {
  //     title: '质检登记导入'
  //   }
  // },
  // {
  //   name: 'SecondaryReview',
  //   path: '/secondaryReview',
  //   component: () => import('@/views/qualityTestingManage/secondaryReview'),
  //   meta: {
  //     title: '质检审核'
  //   }
  // },
  // {
  //   name: 'CustomerServiceStatement',
  //   path: '/customerServiceStatement',
  //   component: () => import('@/views/qualityTestingManage/customerServiceStatement'),
  //   meta: {
  //     title: '质检申诉'
  //   }
  // },
  {
    name: 'QualityInspectionSummary',
    path: '/qualityInspectionSummary',
    component: () => import('@/views/qualityTestingManage/qualityInspectionSummary'),
    meta: {
      title: '质检汇总'
    }
  },
  {
    name: 'QualityInspectionAnalysis',
    path: '/qualityInspectionAnalysis',
    component: () => import('@/views/qualityTestingManage/qualityInspectionAnalysis'),
    meta: {
      title: '质检分析'
    }
  },
  {
    name: 'Notify',
    path: '/notify',
    component: () => import('@/views/qualityTestingManage/notify'),
    meta: {
      title: '消息通知'
    }
  },
  {
    name: 'stalkingLevelConfiguration',
    path: '/newProduct/stalkingLevelConfiguration',
    component: () => import('@/views/newProduct/stalkingLevelConfiguration/base-config/base-config'),
    meta: {
      title: '滞销等级基础配置'
    }
  },
  // {
  //   name: 'SevendaysDeliveryArea',
  //   path: 'sevendaysDeliveryArea',
  //   component: () => import('@/views/dataImport/sevendaysDeliveryArea/sevendaysDeliveryArea'),
  //   meta: {
  //     title: '7天发货区域'
  //   }
  // },
  {
    name: 'SalesTarget',
    path: 'salesTarget',
    component: () => import('@/views/dataImport/salesTarget/salesTarget'),
    meta: {
      title: '销售目标'
    }
  },
  {
    name: 'ProductingPackageStatus',
    path: 'productingPackageStatus',
    component: () => import('@/views/dataImport/productingPackageStatus/productingPackageStatus'),
    meta: {
      title: '包件在产状态'
    }
  },
  // {
  //   name: 'GiftRegister',
  //   path: '/giftRegister',
  //   component: () => import('@/views/giftsManagement/giftRegister/giftRegister'),
  //   meta: {
  //     title: '赠品登记'
  //   }
  // },
  // {
  //   name: 'OfflineGiftImport',
  //   path: '/offlineGiftImport',
  //   component: () => import('@/views/giftsManagement/giftRegister/offlineGift/offlineGiftImport'),
  //   meta: {
  //     title: '线下赠品导入'
  //   }
  // },
  // {
  //   name: 'OnlineGiftImport',
  //   path: '/onlineGiftImport',
  //   component: () => import('@/views/giftsManagement/giftRegister/onlineGift/onlineGiftImport'),
  //   meta: {
  //     title: '线上赠品导入'
  //   }
  // },
  // {
  //   name: 'GifToExamine',
  //   path: '/gifToExamine',
  //   component: () => import('@/views/giftsManagement/gifToExamine/gifToExamine'),
  //   meta: {
  //     title: '赠品审核'
  //   }
  // },
  // {
  //   name: 'GifToExamineImport',
  //   path: '/gifToExamineImport',
  //   component: () => import('@/views/giftsManagement/gifToExamine/gifToExamineImport'),
  //   meta: {
  //     title: '赠品审核导入'
  //   }
  // },
  // {
  //   name: 'GiftsSummary',
  //   path: '/giftsSummary',
  //   component: () => import('@/views/giftsManagement/giftsSummary/giftsSummary'),
  //   meta: {
  //     title: '赠品汇总'
  //   }
  // },
  // {
  //   name: 'GiftsSummaryImport',
  //   path: '/giftsSummaryImport',
  //   component: () => import('@/views/giftsManagement/giftsSummary/giftsSummaryImport'),
  //   meta: {
  //     title: '赠品汇总导入'
  //   }
  // },
  // {
  //   name: 'JDproprietaryStock',
  //   path: '/JDproprietaryStock',
  //   component: () => import('@/views/JD/JDproprietaryStock/JDproprietaryStock'),
  //   meta: {
  //     title: '京东自营入仓'
  //   }
  // },
  // {
  //   name: 'TransferPlanQuery',
  //   path: '/transferPlanQuery',
  //   component: () => import('@/views/JD/transferPlanQuery/transferPlanQuery'),
  //   meta: {
  //     title: '要货计划查询'
  //   }
  // },
  // {
  //   name: 'SheetManagement',
  //   path: '/sheetManagement',
  //   component: () => import('@/views/sheetManagement/sheetManagement'),
  //   meta: {
  //     title: '报表中心'
  //   }
  // }
  ]
},
{//配置中心
  path: '/configurationCenter',
  component: Layout,
  // meta: {
  //   title: '配置中心',
  //   icon: 'icon-rizhi'
  // },
  children: [
    {
      path: 'dataPermissionManagement',
      name: 'DataPermissionManagement',
      component: () => import('@/views/configurationCenter/dataPermissionManagement/dataPermissionManagement'),
      meta: {
        title: '数据权限管理'
      }
    },
    {
      path: 'dataPermissionConfiguration',
      name: 'DataPermissionConfiguration',
      component: () => import('@/views/configurationCenter/dataPermissionConfiguration/dataPermissionConfiguration'),
      meta: {
        title: '数据权限配置'
      }
    },
    {
      path: 'NationalSubsidiesType',
      name: 'nationalSubsidiesType',
      component: () => import('@/views/configurationCenter/nationalSubsidiesType/nationalSubsidiesType'),
      meta: {
        title: '国补类型配置'
      }
    },
    {
      path: 'stroeMangement',
      name: 'StroeMangement',
      component: () => import('@/views/configurationCenter/stroeMangement/stroeMangement'),
      meta: {
        title: '店铺管理'
      }
    },
    // {
    //   path: 'shippingCycleLimit',
    //   name: 'ShippingCycleLimit',
    //   component: () => import('@/views/configurationCenter/shippingCycleLimit/shippingCycleLimit'),
    //   meta: {
    //     title: '平台发货周期限制'
    //   }
    // },
    {
      path: 'stroeStaffMangement',
      name: 'StroeStaffMangement',
      component: () => import('@/views/configurationCenter/stroeStaffMangement/stroeStaffMangement'),
      meta: {
        title: '店铺客服人员管理'
      }
    },
    {
      path: 'qualityTestingRuleMange',
      name: 'QualityTestingRuleMange',
      component: () => import('@/views/configurationCenter/qualityTestingRuleMange/qualityTestingRuleMange'),
      meta: {
        title: '质检规则配置'
      }
    },
    {
      path: 'qualityAuditConfig',
      name: 'QualityAuditConfig',
      component: () => import('@/views/configurationCenter/qualityAuditConfig/qualityAuditConfig'),
      meta: {
        title: '质检审核配置'
      }
    },
    {
      path: 'dabooPriceControlPeriod',
      name: 'DabooPriceControlPeriod',
      component: () => import('@/views/configurationCenter/dabooPriceControlPeriod/dabooPriceControlPeriod'),
      meta: {
        title: '达播控价期配置'
      }
    },
  ]
},
{
  path: '/dataImport',
  component: Layout,
  // meta: {
  //   title: '数据导入',
  //   icon: 'icon-rizhi'
  // },
  children: [
    {
      path: '/dataImport/:type',
      name: 'CommonDataImport',
      component: () => import('@/views/dataImport/dataImport'),
      meta: {
        title: ''
      }
    },
    {
      path: '/whiteList',
      name: 'WhiteList',
      component: () => import('@/views/dataImport/whiteList/whiteList'),
      meta: {
        title: '白名单'
      }
    },
    {
      path: '/firstBatch',
      name: 'firstBatch',
      component: () => import('@/views/dataImport/firstBatch/firstBatch'),
      meta: {
        title: '新品首批库导入'
      }
    },
    {
      path: '/wanjiaPriceMaintainImport',
      name: 'WanjiaPriceMaintainImport',
      component: () => import('@/views/dataImport/wanjiaPriceMaintainImport/wanjiaPriceMaintainImport'),
      meta: {
        title: '万家采购价导入'
      }
    },
    {
      name: 'JDproprietaryStockImport',
      path: '/JDproprietaryStockImport',
      component: () => import('@/views/JD/JDproprietaryStockImport/JDproprietaryStockImport'),
      meta: {
        title: '京东自营入仓导入'
      }
    },
    {
      name: 'NewproductProcessImport',
      path: '/newproductProcessImport',
      component: () => import('@/views/dataImport/newproductProcess/newproductProcess'),
      meta: {
        title: '新品进度更新导入'
      }
    },
    {
      name: 'ShootingType',
      path: '/shootingType',
      component: () => import('@/views/dataImport/shootingType/shootingType'),
      meta: {
        title: '拍摄类型导入'
      }
    },
    {
      name: 'ShootingTypeImport',
      path: '/shootingTypeImport',
      component: () => import('@/views/dataImport/shootingType/import'),
      meta: {
        title: '拍摄类型导入'
      }
    },
    {
      name: 'PddBatchModifyPrices',
      path: '/pddBatchModifyPrices',
      component: () => import('@/views/dataImport/pddBatchModifyPrices/pddBatchModifyPrices'),
      meta: {
        title: '拼多多批量修改价格'
      }
    },
    {
      name: 'PddBatchModifyPricesImport',
      path: '/pddBatchModifyPricesImport',
      component: () => import('@/views/dataImport/pddBatchModifyPrices/import'),
      meta: {
        title: '拼多多批量修改价格导入'
      }
    },
    {
      name: 'JDSku',
      path: '/JDSku',
      component: () => import('@/views/dataImport/JDSku/JDSku'),
      meta: {
        title: '京东SKU限售分类'
      }
    },
    {
      name: 'restrictedSaleFailureData',
      path: '/JDSku/restrictedSaleFailureData',
      component: () => import('@/views/dataImport/JDSku/restrictedSaleFailureData'),
      meta: {
        title: '限售失败数据'
      }
    },
    {
      name: 'JDSkuImport',
      path: '/JDSkuImport',
      component: () => import('@/views/dataImport/JDSku/import'),
      meta: {
        title: '京东SKU导入'
      }
    },
    {
      name: 'ProductSplit',
      path: '/productSplit',
      component: () => import('@/views/dataImport/productSplit/index'),
      meta: {
        title: '实木商品拆分产品'
      }
    },
    {
      name: 'ProductSplitImport',
      path: '/productSplitImport',
      component: () => import('@/views/dataImport/productSplit/import'),
      meta: {
        title: '实木商品拆分产品导入'
      }
    },
    {
      name: 'WorkPlanImport',
      path: '/workPlanImport',
      component: () => import('@/views/dataImport/workPlanImport/workPlanImport'),
      meta: {
        title: '工作计划导入-修片'
      }
    },
    {
      name: 'workPlanImportSection',
      path: '/workPlanImportSection',
      component: () => import('@/views/dataImport/workPlanImport/workPlanImportSection'),
      meta: {
        title: '工作计划导入-切片'
      }
    },
    {
      name: 'WordSheet',
      path: '/wordSheet',
      component: () => import('@/views/dataImport/wordSheet/wordSheet.vue'),
      meta: {
        title: '说辞表导入'
      }
    },
    {
      name: 'MessageSheet',
      path: '/messageSheet',
      component: () => import('@/views/dataImport/messageSheet/messageSheet.vue'),
      meta: {
        title: '信息表导入'
      }
    },
    {
      name: 'BomSheet',
      path: '/bomSheet',
      component: () => import('@/views/dataImport/bomSheet/bomSheet.vue'),
      meta: {
        title: 'bom表导入'
      }
    },
    {
      name: 'SubMonthAdjust',
      path: '/subMonthAdjust',
      component: () => import('@/views/dataImport/subMonthAdjust/subMonthAdjust.vue'),
      meta: {
        title: '预估调整量导入'
      }
    },
    // {
    //   name: 'Plan',
    //   path: '/plan',
    //   component: () => import('@/views/dataImport/plan/plan.vue'),
    //   meta: {
    //     title: '预估量导入'
    //   }
    // },
    {
      name: 'NonSalesImport',
      path: '/nonSalesImport',
      component: () => import('@/views/dataImport/nonSalesOrder/nonSalesImport.vue'),
      meta: {
        title: '非销订单导入'
      }
    },
    {
      name: 'LargeSizeDetailsImport',
      path: '/largeSizeDetailsImport',
      component: () => import('@/views/productModelDetails/largeSizeDetails/largeSizeDetailsImport.vue'),
      meta: {
        title: '大型号处理意见导入'
      }
    },
    {
      name: 'ProductDetailsImport',
      path: '/productDetailsImport',
      component: () => import('@/views/productModelDetails/productDetails/productDetailsImport.vue'),
      meta: {
        title: '产品处理意见导入'
      }
    },
    {
      name: 'LabelProducts',
      path: '/labelProducts',
      component: () => import('@/views/dataImport/labelProducts/labelProducts.vue'),
      meta: {
        title: '标签产品导入'
      }
    },
    {
      name: 'WinningList',
      path: '/winningList',
      component: () => import('@/views/dataImport/winningList/winningList.vue'),
      meta: {
        title: '中奖名单导入'
      }
    },
    {
      name: 'JDVipshop',
      path: '/JDVipshop',
      component: () => import('@/views/dataImport/JDVipshop/JDVipshop.vue'),
      meta: {
        title: '京东唯品会导入'
      }
    },
    {
      name: 'NonSalesOrder',
      path: '/nonSalesOrder',
      component: () => import('@/views/dataImport/nonSalesOrder/nonSalesOrder.vue'),
      meta: {
        title: '非销订单'
      }
    },
    {
      name: 'CustomCustomer',
      path: '/customCustomer',
      component: () => import('@/views/dataImport/customCustomer/customCustomer.vue'),
      meta: {
        title: '电商定制客户'
      }
    },
    {
      name: 'CustomImport',
      path: '/customImport',
      component: () => import('@/views/dataImport/customCustomer/customImport.vue'),
      meta: {
        title: '电商定制客户导入'
      }
    },
    {
      name: 'ShippingTime',
      path: '/shippingTime',
      component: () => import('@/views/dataImport/shippingTime/shippingTime.vue'),
      meta: {
        title: '出货时间导入'
      }
    },
    {
      name: 'LiveBroadcastImport',
      path: '/liveBroadcastImport',
      component: () => import('@/views/dataImport/liveBroadcastImport/liveBroadcastImport.vue'),
      meta: {
        title: '直播订单导入'
      }
    },
    {
      name: 'LeisureProducts',
      path: '/leisureProducts',
      component: () => import('@/views/dataImport/leisureProducts/leisureProducts.vue'),
      meta: {
        title: '休闲产品不考核'
      }
    },
    {
      name: 'LeisureProductsImport',
      path: '/leisureProductsImport',
      component: () => import('@/views/dataImport/leisureProducts/import.vue'),
      meta: {
        title: '休闲产品不考核导入'
      }
    },
    {
      name: 'NationalSubsidyOrder',
      path: '/nationalSubsidyOrder',
      component: () => import('@/views/dataImport/nationalSubsidyOrder/nationalSubsidyOrder.vue'),
      meta: {
        title: '国补订单'
      }
    },
    {
      name: 'NationalSubsidyOrderImport',
      path: '/nationalSubsidyOrderImport',
      component: () => import('@/views/dataImport/nationalSubsidyOrder/import.vue'),
      meta: {
        title: '国补订单导入'
      }
    },
  ]
},
{
  path: '/ReturnManagement',
  component: Layout,
  // meta: {
  //   title: '物流',
  //   icon: 'icon-rizhi'
  // },
  children: [
  //   {
  //   name: 'ReturnManagement',
  //   path: '/returnManagement',
  //   component: () => import('@/views/returnManagement/index'),
  //   meta: {
  //     title: '退货管理'
  //   }
  // },
  // {
  //   name: 'Receipt',
  //   path: '/receipt',
  //   component: () => import('@/views/receipt/index'),
  //   meta: {
  //     title: '收货管理'
  //   }
  // },
  // {
  //   name: 'ImportexcelbyReturn',
  //   path: '/returnManagement/importexcelbyReturn',
  //   component: () => import('@/components/importexcel/ImportExcel'),
  //   meta: {
  //     title: '导入'
  //   }
  // },
  // {
  //   name: 'ReturnManagementAdd',
  //   path: '/returnManagement/add',
  //   component: () => import('@/views/returnManagement/add'),
  //   meta: {
  //     title: '新增退货'
  //   }
  // },
  // {
  //   name: 'ReturnManagementEdit',
  //   path: '/returnManagement/edit',
  //   component: () => import('@/views/returnManagement/edit'),
  //   meta: {
  //     title: '退货编辑'
  //   }
  // },
  // {
  //   name: 'ReturnManagementConfiguration',
  //   path: '/returnManagement/configuration',
  //   component: () => import('@/views/returnManagement/configuration'),
  //   meta: {
  //     title: '基础配置'
  //   },
  // },
  // {
  //   name: 'ReturnManagementDetail',
  //   path: '/returnManagement/detail',
  //   component: () => import('@/views/returnManagement/detail'),
  //   meta: {
  //     title: '退货详情'
  //   }
  // },
  // {
  //   name: 'ReceiptConfirm',
  //   path: '/returnManagement/confirm',
  //   component: () => import('@/views/receipt/confirm'),
  //   meta: {
  //     title: '确认收货'
  //   }
  // },
  // {
  //   name: 'ReceiptEdit',
  //   path: '/returnManagement/receiptEdit',
  //   component: () => import('@/views/receipt/edit'),
  //   meta: {
  //     title: '编辑收货'
  //   }
  // },
  // {
  //   name: 'ReceiptDetail',
  //   path: '/returnManagement/receiptDetail',
  //   component: () => import('@/views/receipt/detail'),
  //   meta: {
  //     title: '收货详情'
  //   }
  // }
  ]
},
{
  path: '/Market',
  component: Layout,
  // meta: {
  //   title: '市场',
  //   icon: 'icon-rizhi'
  // },
  children: [
  //   {
  //   name: 'Store',
  //   path: '/Market/store',
  //   component: () => import('@/views/storeData/index'),
  //   meta: {
  //     title: '竞店数据'
  //   }
  // }, {
  //   name: 'ImportexcelbyStore',
  //   path: '/Market/importexcelbyStore',
  //   component: () => import('@/components/importexcel/ImportExcel'),
  //   meta: {
  //     title: '导入'
  //   }
  // },
  // {
  //   name: 'StoreConfiguration',
  //   path: '/Market/Configuration',
  //   // component: () => import('@/views/operationAnalysis/operationAnalysis'),
  //   component: () => import('@/views/storeData/configuration'),
  //   meta: {
  //     title: '基础配置'
  //   }
  // }, {
  //   name: 'GoodsAnalysis',
  //   path: '/goods-analysis',
  //   component: () => import('@/views/goodsAnalysis/goodsAnalysis'),
  //   meta: {
  //     title: '产品总览'
  //   }
  // },
  {
    name: 'GoodsOverview',
    path: '/goods-overview',
    component: () => import('@/views/goodsAnalysis/goodsOverview'),
    meta: {
      title: '产品概览'
    }
  },

  {
    name: 'LargeSizeDetails',
    path: '/largeSizeDetails',
    component: () => import('@/views/productModelDetails/largeSizeDetails/largeSizeDetails'),
    meta: {
      title: '大型号销量明细'
    }
  }, {
    name: 'ProductDetails',
    path: '/productDetails',
    component: () => import('@/views/productModelDetails/productDetails/productDetails'),
    meta: {
      title: '产品销量明细'
    }
  },
  // {
  //   name: 'CommoditySales',
  //   path: '/commoditySales',
  //   component: () => import('@/views/commoditySales/commoditySales'),
  //   meta: {
  //     title: '商品销量表'
  //   }
  // }, 
  // {
  //   name: 'ProductSales',
  //   path: '/productSales',
  //   component: () => import('@/views/productSales/productSales'),
  //   meta: {
  //     title: '产品销量表'
  //   }
  // }, 
  {
    name: 'ComprehensiveQuery',
    path: '/comprehensiveQuery',
    component: () => import('@/views/intelligentRecom/comprehensiveQuery/comprehensiveQuery'),
    meta: {
      title: '产品综合查询'
    }
  }, {
    name: 'ModelQuery',
    path: '/modelQuery',
    component: () => import('@/views/intelligentRecom/modelQuery/modelQuery'),
    meta: {
      title: '型号推荐查询'
    }
  }, {
    name: 'ProductComparison',
    path: '/productComparison',
    component: () => import('@/views/intelligentRecom/productComparison/productComparison'),
    meta: {
      title: '产品对比'
    }
  }, {
    name: 'salesVolumeQuery',
    path: '/salesVolumeQuery',
    component: () => import('@/views/intelligentRecom/salesVolumeQuery/salesVolumeQuery'),
    meta: {
      title: '销量组合查询'
    }
  }, 
  // {
  //   name: 'ProducDrawing',
  //   path: '/producDrawing',
  //   component: () => import('@/views/intelligentRecom/producDrawing/producDrawing'),
  //   meta: {
  //     title: '产品三维图查询'
  //   }
  // }, 
  {
    name: 'StoreMainPushModel',
    path: '/storeMainPushModel',
    component: () => import('@/views/intelligentRecom/storeMainPushModel/storeMainPushModel'),
    meta: {
      title: '店铺主推型号'
    }
  }, {
    name: 'ImportMainBigModel',
    path: '/importMainBigModel',
    component: () => import('@/views/intelligentRecom/storeMainPushModel/importMainBigModel'),
    meta: {
      title: '店铺主推型号导入'
    }
  }, {
    name: 'PermissionConfiguration',
    path: '/permissionConfiguration',
    component: () => import('@/views/intelligentRecom/permissionConfiguration/permissionConfiguration'),
    meta: {
      title: '产品智能推荐权限配置'
    }
  }, {
    name: 'GoodsAnalysisInfo',
    path: '/goods-analysis-info',
    component: () => import('@/views/goodsAnalysis/info/info'),
    meta: {
      title: '产品概览明细'
    }
  }, {
    name: 'BaseConf',
    path: '/baseConf',
    component: () => import('@/views/goodsAnalysis/baseConf/baseConf'),
    meta: {
      title: '产品概览基础配置'
    }
  },
  // {
  //   name: 'NewBehavior',
  //   path: '/newBehavior',
  //   component: () => import('@/views/goodsAnalysis/newBehavior/newBehavior'),
  //   meta: {
  //     title: '新品表现'
  //   }
  // }, 
  {
    name: 'YearBehavior',
    path: '/yearBehavior',
    component: () => import('@/views/goodsAnalysis/yearBehavior/yearBehavior'),
    meta: {
      title: '产品年度分析',
    },
  }, {
    name: 'ProBehavior',
    path: '/proBehavior',
    component: () => import('@/views/goodsAnalysis/proBehavior/proBehavior'),
    meta: {
      title: '产品表现'
    }
  }, {
    name: 'ProBehaviorYear',
    path: '/proBehaviorYear',
    component: () => import('@/views/goodsAnalysis/proBehaviorYear/proBehaviorYear'),
    meta: {
      title: '年度产品表现'
    }
  }
  ]
},
{
  path: '/imExport',
  component: Layout,
  // meta: {
  //   title: '导入导出',
  //   icon: 'icon-rizhi'
  // },
  children: [{
    name: 'ExportTask',
    path: 'exportTask',
    component: () => import('@/views/imExport/exportTask/exportTask'),
    meta: {
      title: '导出列表'
    }
  }
  ]
},
{
  path: '*',
  redirect: '/home'
}
];


const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  // routes: constantRoutes
  routes: [...constantRoutes, ...asyncRoutes]
})

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
